(function(){
"use strict";
class MGCSCalculator extends HTMLElement{
  connectedCallback(){
    if(this.__initialized)return;
    this.__initialized=true;
    var root=this;
    const DATA = {
      motor: [
        {s:6, t:"Normal gait, normal spinal reflexes"},
        {s:5, t:"Hemiparesis, tetraparesis or decerebrate rigidity"},
        {s:4, t:"Recumbent, intermittent extensor rigidity"},
        {s:3, t:"Recumbent, constant extensor rigidity"},
        {s:2, t:"Recumbent, constant extensor rigidity with opisthotonus"},
        {s:1, t:"Recumbent, hypotonia of muscles, depressed or absent spinal reflexes"}
      ],
      brainstem: [
        {s:6, t:"Normal PLR and oculocephalic reflexes"},
        {s:5, t:"Slow PLR, normal to reduced oculocephalic reflexes"},
        {s:4, t:"Bilateral unresponsive miosis, normal to reduced oculocephalic reflexes"},
        {s:3, t:"Pinpoint pupils, reduced to absent oculocephalic reflexes"},
        {s:2, t:"Unilateral unresponsive mydriasis, reduced to absent oculocephalic reflexes"},
        {s:1, t:"Bilateral unresponsive mydriasis, reduced to absent oculocephalic reflexes"}
      ],
      consciousness: [
        {s:6, t:"Occasional periods of alertness, responsive to environment"},
        {s:5, t:"Depression or delirium, capable of responding but response may be inappropriate"},
        {s:4, t:"Semicomatose, responsive to visual stimuli"},
        {s:3, t:"Semicomatose, responsive to auditory stimuli"},
        {s:2, t:"Semicomatose, responsive only to repeated noxious stimuli"},
        {s:1, t:"Comatose, unresponsive to repeated noxious stimuli"}
      ]
    };
    
    const state = {motor:null, brainstem:null, consciousness:null};
    
    // Survival probability model from Platt et al. (2001): logistic fit,
    // MGCS 8 ≈ 0.5 probability of survival in first 48h. Reported as an approximate band.
    function survivalPct(total){
      const p = 1/(1+Math.exp(-(total-8)*0.55));
      return Math.round(p*100);
    }
    
    function build(){
      root.querySelectorAll('.cat').forEach(sec=>{
        const cat = sec.dataset.cat;
        const box = sec.querySelector('.opts');
        DATA[cat].forEach(o=>{
          const id = cat+'_'+o.s;
          const lab = document.createElement('label');
          lab.className='opt';
          lab.innerHTML = `<input type="radio" name="${cat}" value="${o.s}" id="${id}">
            <span class="txt">${o.t}</span><span class="score">${o.s}</span>`;
          lab.querySelector('input').addEventListener('change',()=>{
            state[cat]=o.s;
            box.querySelectorAll('.opt').forEach(x=>x.classList.remove('sel'));
            lab.classList.add('sel');
            render();
          });
          box.appendChild(lab);
        });
      });
    }
    
    function render(){
      const vals = [state.motor,state.brainstem,state.consciousness];
      const done = vals.every(v=>v!==null);
      const totalEl = root.querySelector('#total');
      const bandBox = root.querySelector('#bandBox');
      const prob = root.querySelector('#prob');
      const pin = root.querySelector('#pin');
    
      if(!done){
        totalEl.textContent='–';
        bandBox.innerHTML='<div class="incomplete" id="incomplete">Select one option in each category to calculate the score.</div>';
        prob.style.display='none';
        pin.style.left='50%';
        return;
      }
    
      const total = vals.reduce((a,b)=>a+b,0);
      totalEl.textContent=total;
      pin.style.left = ((total-3)/15*100)+'%';
    
      let band, cls, desc;
      if(total>=15){band='Good prognosis';cls='good';desc='Mild neurological impairment. Favourable outlook with prompt, appropriate care.';}
      else if(total>=9){band='Guarded prognosis';cls='guarded';desc='Moderate impairment. Outcome uncertain — treat aggressively and re-score frequently.';}
      else {band='Grave prognosis';cls='grave';desc='Severe impairment. Low probability of survival; intensive intervention required.';}
    
      const bg = getComputedStyle(root).getPropertyValue('--mgcs-'+cls+'-bg');
      const col = getComputedStyle(root).getPropertyValue('--mgcs-'+cls);
      bandBox.innerHTML = `<div class="band" style="background:${bg}">
          <div class="label" style="color:${col}">${band}</div>
          <div class="desc">${desc}</div></div>`;
    
      const pct = survivalPct(total);
      prob.style.display='block';
      prob.innerHTML = `Estimated probability of survival in the first 48h: <b>~${pct}%</b><br>
        <span style="font-size:12px">Approximate, from the MGCS validation model. Serial scoring and the clinical trend matter more than any single number.</span>`;
    }
    
    root.querySelector('#reset').addEventListener('click',()=>{
      state.motor=state.brainstem=state.consciousness=null;
      root.querySelectorAll('input[type=radio]').forEach(r=>r.checked=false);
      root.querySelectorAll('.opt').forEach(x=>x.classList.remove('sel'));
      render();
    });
    
    build();
    render();
  }
}
if(!customElements.get("s-mgcs-calculator"))customElements.define("s-mgcs-calculator",MGCSCalculator);
})();
